import cx from 'classnames';
import Link from 'next/link';
import { ReactNode } from 'react';
import Typo from '../Typography';

export const BreadcrumbLink = ({
  leftAdornment,
  children,
  ...props
}: {
  href: string;
  leftAdornment?: ReactNode;
  children: ReactNode;
  onClick?: VoidFunction;
}) => (
  <Link
    className={cx(
      'group cursor-pointer relative flex items-center min-w-0', // min-w-0 allows shrinking
      'hover:text-t2-primary-brandColor',
    )}
    {...props}
  >
    <div className="flex items-center gap-x-2 truncate">
      {leftAdornment && <div className="group-hover:opacity-75">{leftAdornment}</div>}
      <Label>{children}</Label>
    </div>
  </Link>
);

const Label = ({ children }: { children: ReactNode }) => (
  <Typo
    className={cx(
      'text-base min-w-0 truncate overflow-hidden text-ellipsis', // Apply truncation properly
      'text-t2-neutral-grey09 group-hover:text-t2-primary-brandColor transition-colors whitespace-nowrap',
    )}
  >
    {children}
  </Typo>
);
